import React from 'react';
let counter = 0;
function useIsomorphicId() {
    return React.useState(()=>`uid-${++counter}`)[0];
}
const useId = typeof React.useId === 'function' ? React.useId : useIsomorphicId;
export default useId;
